import React from "react";
// import Navbar from "../components/Navbar";
import DealCard from "../components/DealCard";
import Modal from "../components/Modal";
import Parser from "html-react-parser";
import "../css/deallist.css";
import { useLoading, useDeals, useSearch, usePage } from "../hooks";
import ScrollTop from "../components/ScrollTop";
import Skeleton from '@material-ui/lab/Skeleton';
import Translate from "../components/Translate";
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
//import postscribe from 'postscribe';
import InfiniteScroll from "react-infinite-scroll-component";

const DEALS_A_PAGE = 40;

const Home = () => {

  const [isLoading] = useLoading();
  const [deals] = useDeals();
  const [searchString] = useSearch();
  const [page, setPage] = usePage();

  const [guideLoading, setGuideLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [store, setStore] = React.useState(undefined);
  const [guide, setGuide] = React.useState(undefined);

  const homeChip = (
    <Chip
      avatar={<Avatar>H</Avatar>}
      key="home"
      label="Home"
      variant="outlined"
      color="primary"
      style={{ position: 'fixed', right: '10px', top: '10px', zIndex: '555' }}
    />
  );

  // React.useEffect(() => {
  //   postscribe('#amzn_mobile_container', `<script type="text/javascript">
  //   amzn_assoc_ad_type = "link_enhancement_widget";
  //   amzn_assoc_tracking_id = "disdaren-20";
  //   amzn_assoc_linkid = "d3432bb8b789c7ba107302d9e96908c8";
  //   amzn_assoc_placement = "";
  //   amzn_assoc_marketplace = "amazon";
  //   amzn_assoc_region = "US";
  // </script>
  // <script src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&Operation=GetScript&ID=OneJS&WS=1&MarketPlace=US"></script>  
  //   `);
  // }, []);

  const viewDeals = React.useMemo(() => {
    return deals.filter((deal) => {
      const { dname, dstore, etitle } = deal;
      return dname.toLowerCase().includes(searchString) || dstore.toLowerCase().includes(searchString) || etitle.toLowerCase().includes(searchString);
    });
  }, [deals, searchString]);

  const totalPage = React.useMemo(() => Math.ceil(viewDeals.length / DEALS_A_PAGE), [viewDeals]);

  const dealCards = React.useMemo(() => {
    if (viewDeals.length > 0) {
      return viewDeals.slice(0, DEALS_A_PAGE * page).map((deal) => {
        return (
          <DealCard
            deal={deal}
            key={deal.dno}
            setModalOpen={setModalOpen}
            setStore={setStore}
            setGuide={setGuide}
            setGuideLoading={setGuideLoading}
          />
        );
      });
    }
    return "No Deals Found!";
  }, [viewDeals, page]);

  const toggle = React.useCallback(() => setModalOpen(!modalOpen), [setModalOpen, modalOpen]);

  const skeletons = [...Array(40)].map((x, idx) => <div key={idx} style={{ width: "270px", height: "370px" }}><Skeleton variant="rect" animation="wave" width={250} height={350} /></div>);

  return (
    <React.Fragment>
      {homeChip}
      <div id="amzn_mobile_container" />
      <div
        style={{ marginLeft: "50px", marginRight: "50px", marginTop: "20px", display: 'flex', alignItem: 'center' }}
      >
        <ScrollTop home={'yes'}/>
        <InfiniteScroll
          dataLength={dealCards.length} //This is important field to render the next data
          next={()=>{setPage(page+1);}}
          hasMore={(page < totalPage)}
      >
        <div className="deallist"> {isLoading ? skeletons : dealCards}</div>
      </InfiniteScroll>
      </div>
      <Modal isOpen={modalOpen} toggle={toggle} header={`${store} Shopping Guide`} body={guideLoading ?
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </div> :
        guide ? Parser(Translate(guide)) :
          "No guide available."} />
    </React.Fragment>
  );
};

export default Home;
